import React, {useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeftLong, faFileArrowDown, faSpinner} from "@fortawesome/free-solid-svg-icons";
import Header from "./header";
import Breadcrumb from "./breadcrumb";
import "../App.scss";
import "../styles/detail.scss";

export default function DetailPage(props) {

  const {uri} = useParams();
  const navigate = useNavigate();
  const baseUrlApi = props.baseApiUrl;
  const imgRoute = baseUrlApi + "/api/File/";
  const [detailItem, setDetailItem] = useState(null);
  const [isLoadingCardData, setIsLoadingCardData] = useState(null);
  const slider_settings = {
    dots: true,
    infinite: true,
    lazyLoad: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  useEffect(() => {
    setIsLoadingCardData(true);
    axios.get(baseUrlApi + "/api/EntityWeb/GetEntity?uri=" + uri).then((response) => {

      let receivedItem = response.data;
      receivedItem.metadata?.forEach((meta, i) => {
        if (meta.type === "CCLicenses") {
          receivedItem.License = meta.value;
          delete receivedItem.metadata[i];
        }
        if (meta.type === "RightHolder") {
          receivedItem.RightHolder = meta.value;
          delete receivedItem.metadata[i];
        }
        if (meta.type === "Font") {
          receivedItem.Font = meta.value;
          delete receivedItem.metadata[i];
        }
      });

      setDetailItem(response.data);
      setIsLoadingCardData(false);
    });
  }, [uri]);

  return (
    <section className="detailPage">
      {/*{console.log(detailItem)}*/}
      {/*<Header/>*/}
      {/*<Breadcrumb/>*/}
      <div className="body">
        <div className="goBack" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeftLong}/> tornar
        </div>
        {isLoadingCardData ? (
          <div className="loading-dades">
            <h2>Carregant fitxa...</h2>
            <FontAwesomeIcon icon={faSpinner} spin size="6x"/>
          </div>
        ) : (
          <div></div>
        )}

        {detailItem && (
          <div className={((detailItem.gallery === null || detailItem.gallery === undefined) ? "d-item" : "d-item has_gallery")}>
            <div className="d-content">
              {detailItem?.metadata?.map(
                (el, i) =>
                  el.type === "Referència" && (
                    <div className="d-ref" key={i}>
                      Ref. {el.value}
                    </div>
                  )
              )}
              <div className="d-name">
                <div>{detailItem.name}</div>
              </div>
              {detailItem.doc && (
                <a className="d-link" id={detailItem.doc} target="blank"
                   href={baseUrlApi + `/api/File/download/${detailItem.doc}`}>
                  <FontAwesomeIcon icon={faFileArrowDown} size="lg"/> {"Descarregar"}
                </a>
              )}
              <div className="d-details">
                <div className="d-det-item">
                  <div className="d-det-title">{"Categoria: "}</div>
                  <div className="d-det-text">{detailItem.type}</div>
                </div>
                {detailItem?.metadata?.map(
                  (elem, j) =>
                    elem.type !== "Referència" && (
                      <div className="d-det-item" key={j}>
                        <div className="d-det-title">
                          {elem.type}
                          {": "}
                        </div>
                        <div className="d-det-text">{elem.value}</div>
                      </div>
                    )
                )}

                {/*"Font" forced to be bottom */}
                {detailItem.Font && (
                  <div className="d-det-item" key="custom_font">
                    <div className="d-det-title">
                      Font:
                    </div>
                    <div className="d-det-text">{detailItem.Font}</div>
                  </div>
                )}

              </div>
              <div className="right_holder_license">
                {detailItem.RightHolder && (
                  <div className="rights"><span className="label">Drets:</span> {detailItem.RightHolder}</div>
                )}
                {(detailItem.License) && (
                  <div className="license"><span className="label">Llicencia:</span>  {detailItem.License}</div>
                )}
              </div>

              {!!detailItem.children?.length && (
                <div className="d-children">
                  <div className="d-ch-title">{"Conté: "}</div>
                  <div className="d-ch-items">
                    {detailItem?.children?.map(
                      (child, k) =>
                        child.type !== "Referència" && (
                          <Link className="d-ch-item" id={child.uri} to={`/detail/${child.uri}`} key={k}>
                            {child.img && <img src={`${imgRoute}${child.img}`} alt="Imagen"/>}
                            <div>{child.name}</div>
                          </Link>
                        )
                    )}
                  </div>
                </div>
              )}
            </div>

            {/* GALLERY or IMAGE goes inside here*/}
            <div className="gallery-container">
              {(detailItem.gallery !== null && detailItem.gallery?.length > 0) ? (
                <Slider {...slider_settings}>
                  {detailItem.gallery.map((slide, i) => (
                    <div className="detail-slide" key={i}>
                      <figure>
                        <div className="download_button"
                             onClick={(e) => window.location.href = baseUrlApi + `/api/File/download/${slide.imgH}`}>
                          <FontAwesomeIcon icon={faFileArrowDown} size="lg"/>
                          <span>High quality</span>
                        </div>

                        <img src={`${imgRoute}${slide.img}`} alt="Imagen"/>
                        {/*<img src="https://picsum.photos/640/720" alt="Imagen"/>*/}
                        <figcaption>{slide.title}</figcaption>
                      </figure>
                    </div>
                  ))}
                </Slider>
              ) : (
                <div className="detail-slide">
                  {detailItem.img && (
                    <figure>
                      <div className="download_button"
                           onClick={(e) => window.location.href = baseUrlApi + `/api/File/download/${detailItem.img}`}>
                        <FontAwesomeIcon icon={faFileArrowDown} size="lg"/>
                        <label>High quality</label>
                      </div>
                      <img src={`${imgRoute}${detailItem.img}`} alt="Imagen"/>
                    </figure>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}